import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowRight, X } from "@phosphor-icons/react";
import { track } from "@/lib/analytics";

export const StickyDemoBar = () => {
  const [show, setShow] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;
      const nearBottom = window.innerHeight + y > document.body.scrollHeight - 700;
      setShow(y > 900 && !nearBottom);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const hiddenRoutes = ["/contact", "/medical-billing-rcm"];
  if (hiddenRoutes.includes(pathname) || dismissed) return null;

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="sticky-demo-bar"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 24 }}
          transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-5 right-5 z-40 flex items-center gap-3 rounded-2xl border border-slate-200 bg-white/90 backdrop-blur-xl px-4 py-3 shadow-xl max-w-[92vw]"
        >
          <span className="hidden sm:block h-8 w-1 rounded-full zoc-gradient-bar" />
          <p className="text-sm text-slate-600 pr-1">
            <span className="font-semibold text-[#0B2A4E]">See ZOC in action</span> — platform + care team.
          </p>
          <Link
            to="/contact"
            data-testid="sticky-demo-cta"
            onClick={() => track("demo_click", { source: "sticky_bar" })}
            className="group inline-flex items-center gap-1.5 rounded-full bg-[#0B2A4E] text-white px-4 py-2 text-sm font-semibold shadow-sm transition-colors duration-200 hover:bg-[#08203B]"
          >
            Book a demo
            <ArrowRight weight="bold" size={14} className="transition-transform duration-200 group-hover:translate-x-0.5" />
          </Link>
          <button
            onClick={() => setDismissed(true)}
            data-testid="sticky-demo-dismiss"
            aria-label="Dismiss"
            className="grid place-items-center h-7 w-7 rounded-full text-slate-400 hover:bg-slate-100 hover:text-slate-600 transition-colors"
          >
            <X size={15} />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
